import * as React from "react";
import { Link } from 'gatsby';
import { Container, Navbar, Row, Col, Image, } from 'react-bootstrap';
// import CookieConsent from 'react-cookie-consent';
// import ModalPopup from "./modal-popup";

import logoWhite from '../images/logo-white.svg';

const Footer = () => (
  <>
    <footer className="footer">
      <div className="footer-top py-5">
        <Container>
          <Row className="justify-content-between g-4">
            <Col lg={3}>
              <div className="footer-about-us">
                <div className="mb-3">
                  <Navbar.Brand>
                    <Image loading="lazy" className="lazyload" src={logoWhite} width={100} height={52} alt="logo" />
                  </Navbar.Brand>
                </div>
                <p className="me-5 mb-4">Digipay leverages cutting-edge technologies to offer top-notch FinTech services like real-time transfers, payments (P2P & P2M), settlements, and reconciliations.</p>
                <div className="social-icon d-flex ms-auto">
                  <a href="https://www.facebook.com/digipay.guru" aria-label="facebook" rel="noreferrer" target="_blank"><i className="icon zmdi zmdi-hc-fw zmdi-facebook"></i></a>
                  <a href="https://twitter.com/DigipayGuru" aria-label="twitter" rel="noreferrer" target="_blank"><i className="icon zmdi zmdi-hc-fw zmdi-twitter"></i></a>
                  <a href="https://www.linkedin.com/company/digipay-ewallet/" aria-label="linkedin" rel="noreferrer" target="_blank"><i className="icon zmdi zmdi-hc-fw zmdi-linkedin"></i></a>
                  <a href="https://www.instagram.com/digipay.guru/" aria-label="instagram" rel="noreferrer" target="_blank"><i className="icon zmdi zmdi-hc-fw zmdi-instagram"></i></a>
                  <a href="https://www.youtube.com/channel/UC0idP2LkVrJ7lryMuWIR5DA" aria-label="youtube" rel="noreferrer" target="_blank"><i className="icon zmdi zmdi-hc-fw zmdi-youtube-play"></i></a>
                </div>
              </div>
            </Col>
            <Col lg={3}>
              <h3 className="h4 text-white mb-3">Quick Links</h3>
              <ul className="list-unstyled footer-menu">
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/our-usp">Our USP</Link></li>
                <li><Link to="/digipay-top-notch-application-security">Security</Link></li>
                <li><Link to="/blog">Blog</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>
              </ul>
            </Col>
            <Col lg={3}>
              <h3 className="h4 text-white mb-3">Solutions</h3>
              <ul className="list-unstyled footer-menu">
                <li><Link to="/mobile-money-payment-solutions">Mobile Money</Link></li>
                <li><Link to="/agency-banking-solutions">Agency Banking</Link></li>
                <li><Link to="/cross-border-payment-solutions">International Remittance</Link></li>
                <li><Link to="/prepaid-cards-solution">Cards</Link></li>
                <li><Link to="/ekyc-solution">eKYC</Link></li>
                <li><Link to="/scan-and-thru-solution">Scan&Thru</Link></li>
                {/* <li><Link to="/mpos-solution">mPOS</Link></li> */}
                {/* <li><Link to="/merchant-payment-solutions">Merchant Solution</Link></li> */}
              </ul>
            </Col>
            <Col lg={3}>
              {/* <h3 className="h4 text-white mb-3">Quick Contact</h3>
              <ul className="list-unstyled footer-menu">
                <li><span className="address">1st Floor, Meem Procon,<br />Nr. Indraprastha business Park,<br />beside DAV School, Makarba,<br />Ahmedabad-380051</span></li>
              </ul> */}
              <h3 className="h4 text-white">Reach us</h3>
              <ul className="list-unstyled footer-menu font-size-16">
                <li><a href='mailto:hello@digipay.guru'>hello@digipay.guru</a></li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="copyrights py-4">
        <Container className="d-flex align-items-center">
          <span className="text-white opacity-50">© 2024 DigiPay.Guru All Rights Reserved.</span>
        </Container>
      </div>
    </footer>

    {/* <ModalPopup /> */}

    {/* <div className="footer-cookies">
      <Container>
        <Row>
          <Col lg={10} md={12} className="mx-auto">
            <CookieConsent
              location="bottom"
              buttonText="Accept"
              declineButtonText="Decline"
              cookieName="gatsby-gdpr-google-analytics"
              containerClasses="cookies-box"
              contentClasses="text-capitalize"
              buttonClasses="btn btn-primary"
              disableStyles={true}
            >
              <h4 className="mb-3 fw-semibold font-size-22">We use cookies</h4>
              <p className="m-0"> This website uses cookies for analytics, personalization, and advertising.
                If you continue to use our website, you consent to our </p>
            </CookieConsent>
          </Col>
        </Row>
      </Container>
    </div> */}

    {/* <script type="text/javascript">
      {`_linkedin_partner_id = "4059876";
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);
      (function(l) {
if (!l){window.lintrk = function (a, b) { window.lintrk.q.push([a, b]) };
window.lintrk.q=[]}
      var s = document.getElementsByTagName("script")[0];
      var b = document.createElement("script");
      b.type = "text/javascript";b.async = true;
      b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
s.parentNode.insertBefore(b, s);})(window.lintrk);`}
    </script>
    <noscript>
      {`
      <img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=4059876&fmt=gif" />
      `}
    </noscript> */}
  </>
)

export default Footer;
